export const estadoEnvasado = {
  ENVASADO: true,
  NO_ENVASADO: false
}

export const translateEstadoEnvasado = {
  true: 'ENVASADO',
  false: 'NO_ENVASADO'
}